module.exports = __webpack_public_path__ + "static/img/server.729b3ce.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/server.svg
// module id = vu/B
// module chunks = 1